import { createSupabaseClient } from "@/lib/supabase.server";
import { Outlet, redirect } from "@remix-run/react";
import { LoaderFunctionArgs } from "@remix-run/server-runtime";
import { useState } from "react";


export default function Auth(){

    return(
        <div className="">
            <div className="flex lg:justify-between justify-center max-w-[1440px] mx-auto mb-[1vh] px-[5vw] md:px-[80px]">
                <img src="/homescreen4.png" className="w-[calc(592px/1.40)] rounded-sm hidden lg:block xl:w-[592px] xl:h-[678px] self-start"/>

                <div className="max-w-[770px] xl:px-[115.5px] self-center max-h-[960px]">
                    <Outlet/>
                </div>
            </div>

        </div>

    )
}